module.exports = "/images/messaging.svg?d81639c6507bb80f3ffeb587e67b2347";